import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { useIsAuthenticated } from "@/domains/auth/hooks/useCurrentUser";

type RequireAuthProps = {
  children: ReactNode;
};

export function RequireAuth({ children }: RequireAuthProps): React.JSX.Element {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
